import { createReducer, on } from "@ngrx/store";
import moment from "moment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { Notific } from "src/model/class/general classes/notific";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  notificationDeleteCompleteAction,
  notificationInsertCompleteAction,
  notificationLoadErrorAction,
  notificationLoadInitStartAction,
  notificationLoadSuccessAction,
  notificationUnsetKeyStorage,
  notificationUpdateCompleteAction,
} from "../actions/notification-actions";
import { plantUpdateAction } from "../actions/plant.actions";
import { MomentFormats } from "src/model/class/general classes/moment-formats";

/**
 * Initial state of notification store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

/**
 * Reducer for notifications
 */
export const NotificationReducer = createReducer(
  initialState,
  on(
    notificationUnsetKeyStorage,
    (notificationObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  on(
    notificationLoadInitStartAction,
    (notificationObject: GenericStoreApiData, action) => {
      return { ...notificationObject, loaded: false };
    }
  ),
  on(
    notificationLoadSuccessAction,
    (notificationObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.notificationObject,
      };
    }
  ),
  on(
    notificationLoadErrorAction,
    (notificationObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  ),
  on(
    notificationInsertCompleteAction,
    (notificationObject: GenericStoreApiData, action) => {
      const notificationApiObject: GenericApiData = {
        lastAPIModified: moment().format(
          MomentFormats.MOMENT_DATETIME_FORMAT
        ),
        data: [...(notificationObject.data?.data || []), action.newNotification],   //<--- MODIFICATO.
      };

      return {
        ...notificationObject,
        data: notificationApiObject,
      };
    }
  ),
  on(
    notificationUpdateCompleteAction,
    (notificationObject: GenericStoreApiData, action) => {
      const updateNotification: Notific = action.updatedNotification;

      //const listNotificationUpdated: Array<Notific> =

      const notificationObjectDataCp = [...(notificationObject.data?.data || [])];
      const listNotificationUpdated: Array<Notific> =
        notificationObjectDataCp.map((notification: Notific) => {
          if (notification.id === updateNotification.id) {
            notification = updateNotification;
          }

          return notification;
        });

      const updateObject: GenericApiData = {
        lastAPIModified: moment().format(
          MomentFormats.MOMENT_DATETIME_FORMAT
        ),
        data: listNotificationUpdated,
      };

      return {
        ...notificationObject,
        data: updateObject,
      };
    }
  ),
  on(
    notificationDeleteCompleteAction,
    (notificationObject: GenericStoreApiData, action) => {

      const notificationListFromObject = (notificationObject.data?.data || []);

      const listNotificationUpdated: Array<Notific> =
        notificationListFromObject.filter(
          (notification: Notific) => notification.id !== action.idNotification
        );

      const updateObject: GenericApiData = {
        lastAPIModified: moment().format(
          MomentFormats.MOMENT_DATETIME_FORMAT
        ),
        data: listNotificationUpdated,
      };

      return {
        ...notificationObject,
        data: updateObject,
      };
    }
  )
);
